import { render, staticRenderFns } from "./tabs-save.vue?vue&type=template&id=251e7a86"
import script from "./tabs-save.vue?vue&type=script&lang=js"
export * from "./tabs-save.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports